import { Path, Svg, View } from "@react-pdf/renderer";
import React from "react";

const DocumentDetailDateValue = ({
  children,
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <View style={{ display: "flex", flexDirection: "row", gap: "1.5mm" }}>
      <Svg width="4mm" height="4mm" viewBox="0 0 16 18">
        <Path
          d="M4 5.5714H11.9375M3.45833 1V2.37159M12.375 1V2.37142M15 5.37142L15 14C15 15.6569 13.6569 17 12 17H4C2.34315 17 1 15.6569 1 14V5.37142C1 3.71457 2.34315 2.37142 4 2.37142H12C13.6569 2.37142 15 3.71457 15 5.37142Z"
          stroke="#9AA1AB"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </Svg>

      {children}
    </View>
  );
};

export default DocumentDetailDateValue;
